import { v4 as uuidv4 } from 'uuid';
import { Collection, RefBool, RefString } from "@tblabs/truffle";
import { JobOfferDescriptionEntry } from "./JobOfferDescriptionEntry";
import { JobOfferQuestionEntry } from "./JobOfferQuestionEntry";
import { IStorable } from "./IStorable";


export class JobOffer implements IStorable
{
    public Id: string = "";
    public Title = new RefString();
    public IsRecruitmentOpen = new RefBool();
    public Description = new Collection<JobOfferDescriptionEntry>();
    public Form = new Collection<JobOfferQuestionEntry>();
    public CreatedAt: Date = new Date(0);

    constructor(id?: string, title?: string, isRecruitmentOpen?: boolean)
    {
        this.Id = id || uuidv4();
        this.Title.value = title || "(nazwa stanowiska)";
        this.IsRecruitmentOpen.value = isRecruitmentOpen ?? false;
        this.CreatedAt = new Date();
    }
}
